export const baseUrl = 'https://api.pinata.cloud';

export const ERROR_NO_CREDENTIALS_PROVIDED =
    'No credentials provided! Please provide your pinata api key and pinata secret api key or your pinata JWT key as an argument when you start this script';
